import { Component, EventEmitter, HostListener, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomerService } from 'src/app/core/_services/customer.service';
import { StateService } from 'src/app/core/_services/state.service';
import { RegisterErrorComponent } from './register-error/register-error.component';
import { RegisterSuccessComponent } from './register-success/register-success.component';

@Component({
  selector: 'app-register-form-popup',
  templateUrl: './register-form-popup.component.html',
  styleUrls: ['./register-form-popup.component.scss'],
})
export class RegisterFormPopupComponent implements OnInit {
  @Output() isShow = new EventEmitter<boolean>();
  currentLanguage = 'vi';
  registerForm: FormGroup | undefined;
  isError = false;
  isRegister = false;

  listServiceAvailable = ['Quản lý danh mục', 'Tư vấn đầu tư', 'Quản lý quỹ'];
  selectedServices: string[] = [];

  constructor(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RegisterFormPopupComponent>,
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private _stateService: StateService,
    private _customerService: CustomerService,
  ) {
    this._stateService.currentLanguage$.subscribe({
      next: (currentLang: string) => {
        this.currentLanguage = currentLang;
        if (this.currentLanguage === 'en') {
          this.listServiceAvailable = ['Manage categories', 'Investment consulting', 'Fund management'];
        } else {
          this.listServiceAvailable = ['Quản lý danh mục', 'Tư vấn đầu tư', 'Quản lý quỹ'];
        }
      },
    });
    this.registerForm = this.fb.group({
      name: [null, Validators.required],
      phone: [
        null,
        Validators.required,
        // Validators.pattern(
        //   /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
        // ),
      ],
      email: [
        null,
        Validators.required,
        // Validators.pattern(
        //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        // ),
      ],
      services: [null, Validators.required],
      content: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe(() => {
      // Close the dialog
      this.onClose();
    });
  }

  onClose() {
    document.getElementsByClassName('animate__animated')[0].classList.remove('animate__fadeInDown');
    document.getElementsByClassName('animate__animated')[0].classList.add('animate__fadeOutDown');
    setTimeout(() => {
      this.dialogRef.close();
    }, 500);
  }

  register() {
    for (const i in this.registerForm?.controls) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.registerForm?.controls.hasOwnProperty(i)) {
        this.registerForm.controls[i].markAsDirty();
        this.registerForm.controls[i].markAsTouched();
        this.registerForm.controls[i].updateValueAndValidity();
      }
    }
    if (this.registerForm?.valid) {
      this.isRegister = true;
      const data = this.registerForm.getRawValue();
      const query = {
        name: data.name,
        phone: data.phone,
        email: data.email,
        service: data.services.toString(),
        messenger: data.content,
        encodedResponse: '',
      };
      this._customerService.createCustomer(query).subscribe({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (response: any) => {
          if (response && response.success && response.success == '1') {
            this.matDialog.open(RegisterSuccessComponent, {
              disableClose: true,
              panelClass: ['custom-modalbox', 'animate__animated', 'animate__fadeInDown'],
            });
            this.onClose();
          }
        },
        error: () => {
          this.matDialog.open(RegisterErrorComponent, {
            disableClose: true,
            panelClass: ['custom-modalbox', 'animate__animated', 'animate__fadeInDown'],
          });
        },
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  onChangeServices(event: any) {
    // Todo
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.onClose();
  }
}
